import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import SmartifyLogin from "./Authenication/SmartifyLogin";
import SmartifySignup from "./Authenication/SmartifySignup";
import OtpVerification from "./Authenication/OtpVerification";
import ForgotPassword from "./Authenication/ForgotPassword";
import MarathiWordsPage from "./components/MarathiWordsPage";
import MainPage from "./MainPage";

// remove the LanguageToggle import entirely
// import LanguageToggle from "./components/LanguageToggle";

function App() {
  return (
    <Router>
      {/* Language toggle removed from here — now inside the navbar */}
      <Routes>
        <Route path="/" element={<SmartifyLogin />} />
        <Route path="/signup" element={<SmartifySignup />} />
        <Route path="/verify-otp" element={<OtpVerification />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/marathiwords" element={<MarathiWordsPage />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
